import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { CalendarDays, MapPin, Ticket } from "lucide-react";
import { api, qrUrl } from "../../lib/api";
import { AddToCalendar } from "./AddToCalendar";

const nice = (d) => new Date(d + "T00:00").toLocaleDateString([], { weekday: "short", month: "short", day: "numeric", year: "numeric" });

export const TicketWallet = () => {
  const [shows, setShows] = useState(null);
  useEffect(() => {
    api.myTickets().then(setShows).catch(() => setShows([]));
  }, []);

  return (
    <section className="px-5 lg:px-12 mb-16" data-testid="ticket-wallet">
      <h2 className="font-gothic text-4xl flex items-center gap-3 mb-6"><Ticket className="w-7 h-7 text-lime" /> My tickets</h2>
      {shows && shows.length === 0 && (
        <p className="text-slate-400" data-testid="ticket-wallet-empty">
          No tickets for upcoming shows. <Link to="/shows" className="text-lime">Find a show</Link>
        </p>
      )}
      <div className="space-y-6">
        {(shows || []).map((s) => (
          <div key={s.concert_id} className="card-surface rounded-2xl p-6" data-testid={`wallet-show-${s.concert_id}`}>
            <div className="flex flex-wrap items-start justify-between gap-3">
              <Link to={`/shows/${s.concert_id}`} className="font-cond uppercase font-bold text-2xl hover:text-lime transition-colors">{s.title}</Link>
              <AddToCalendar show={{ ...s, id: s.concert_id }} testid={`wallet-calendar-${s.concert_id}`} compact />
            </div>
            <div className="flex flex-wrap gap-x-6 gap-y-1 text-sm text-slate-400 mt-1">
              <span className="flex items-center gap-1.5"><CalendarDays className="w-3.5 h-3.5" /> {nice(s.date)} · {s.time}</span>
              <span className="flex items-center gap-1.5"><MapPin className="w-3.5 h-3.5" /> {s.venue}, {s.city}</span>
            </div>
            <div className="flex flex-wrap gap-4 mt-5">
              {s.tickets.map((t, i) => (
                <figure key={t.code} data-testid={`wallet-ticket-${t.code}`} className={`text-center ${t.used_at ? "opacity-40" : ""}`}>
                  <img src={qrUrl(t.code)} alt={`QR ${t.code}`} className="w-36 h-36 rounded-lg bg-white" />
                  <figcaption className="font-mono-ui text-xs text-lime mt-2">{t.code}</figcaption>
                  <figcaption className="text-[11px] text-slate-500">{t.used_at ? "Used" : `Ticket ${i + 1} of ${s.tickets.length}`}</figcaption>
                </figure>
              ))}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};
